import type { DemoScript } from "../types";
import { FINANCE_SCRIPT_COPY } from "./finance-script.copy";

export const buildFinanceScript = (): DemoScript => [
  {
    id: "fin-intro",
    narrative: FINANCE_SCRIPT_COPY.finIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "fin-main",
    narrative: FINANCE_SCRIPT_COPY.finMain.narrative,
    zoomTargetId: "finance-main-metrics",
    callout: {
      targetId: "finance-main-metrics",
      text: FINANCE_SCRIPT_COPY.finMain.callout,
    },
    durationMs: 5400,
  },
  {
    id: "fin-overview-1",
    narrative: FINANCE_SCRIPT_COPY.finOverview1.narrative,
    durationMs: 1800,
  },
  {
    id: "fin-invoices-open",
    narrative: FINANCE_SCRIPT_COPY.finInvoicesOpen.narrative,
    zoomTargetId: "finance-invoices-modal",
    zoomScale: 1.15,
    callout: {
      targetId: "finance-invoices-modal",
      text: FINANCE_SCRIPT_COPY.finInvoicesOpen.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-invoices-table",
    narrative: FINANCE_SCRIPT_COPY.finInvoicesTable.narrative,
    zoomTargetId: "finance-invoices-table",
    zoomScale: 1.12,
    callout: {
      targetId: "finance-invoices-table",
      text: FINANCE_SCRIPT_COPY.finInvoicesTable.callout,
    },
    durationMs: 5400,
  },
  {
    id: "fin-invoices-status",
    narrative: FINANCE_SCRIPT_COPY.finInvoicesStatus.narrative,
    zoomTargetId: "finance-invoice-row-4",
    zoomScale: 1.1,
    callout: {
      targetId: "finance-invoice-row-4",
      text: FINANCE_SCRIPT_COPY.finInvoicesStatus.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-new-invoice-open",
    narrative: FINANCE_SCRIPT_COPY.finNewInvoiceOpen.narrative,
    zoomTargetId: "finance-new-invoice-modal",
    zoomScale: 1.18,
    callout: {
      targetId: "finance-new-invoice-modal",
      text: FINANCE_SCRIPT_COPY.finNewInvoiceOpen.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-new-invoice-desc",
    narrative: FINANCE_SCRIPT_COPY.finNewInvoiceDesc.narrative,
    zoomTargetId: "finance-new-invoice-desc",
    zoomScale: 1.15,
    callout: {
      targetId: "finance-new-invoice-desc",
      text: FINANCE_SCRIPT_COPY.finNewInvoiceDesc.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-new-invoice-meta",
    narrative: FINANCE_SCRIPT_COPY.finNewInvoiceMeta.narrative,
    zoomTargetId: "finance-new-invoice-meta",
    zoomScale: 1.12,
    callout: {
      targetId: "finance-new-invoice-meta",
      text: FINANCE_SCRIPT_COPY.finNewInvoiceMeta.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-new-invoice-amount",
    narrative: FINANCE_SCRIPT_COPY.finNewInvoiceAmount.narrative,
    zoomTargetId: "finance-new-invoice-amount",
    zoomScale: 1.12,
    callout: {
      targetId: "finance-new-invoice-amount",
      text: FINANCE_SCRIPT_COPY.finNewInvoiceAmount.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-detailed",
    narrative: FINANCE_SCRIPT_COPY.finDetailed.narrative,
    zoomTargetId: "finance-detailed-metrics",
    callout: {
      targetId: "finance-detailed-metrics",
      text: FINANCE_SCRIPT_COPY.finDetailed.callout,
    },
    durationMs: 5400,
  },
  {
    id: "fin-overview-2",
    narrative: FINANCE_SCRIPT_COPY.finOverview2.narrative,
    durationMs: 1800,
  },
  {
    id: "fin-chart-platform",
    narrative: FINANCE_SCRIPT_COPY.finChartPlatform.narrative,
    zoomTargetId: "finance-chart-platform",
    zoomScale: 1.22,
    callout: {
      targetId: "finance-chart-platform",
      text: FINANCE_SCRIPT_COPY.finChartPlatform.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-chart-type",
    narrative: FINANCE_SCRIPT_COPY.finChartType.narrative,
    zoomTargetId: "finance-chart-type",
    zoomScale: 1.25,
    callout: {
      targetId: "finance-chart-type",
      text: FINANCE_SCRIPT_COPY.finChartType.callout,
    },
    durationMs: 5200,
  },
  {
    id: "fin-chart-brands",
    narrative: FINANCE_SCRIPT_COPY.finChartBrands.narrative,
    zoomTargetId: "finance-chart-brands",
    zoomScale: 1.1,
    callout: {
      targetId: "finance-chart-brands",
      text: FINANCE_SCRIPT_COPY.finChartBrands.callout,
    },
    durationMs: 5200,
  },
];
